const STORAGE_KEY = 'teccc.fichaReturn';

export const FLOW_ORIGIN_NAV = {
  cmi: {
    returnTo: '/specialist-flow-cmi',
    returnLabelKey: 'flow.cmi.title',
    returnLabel: 'Panel de control de casos'
  },
  'pre-manager': {
    returnTo: '/specialist-pre-manager-selection',
    returnLabelKey: 'specialist.selection.pre-manager.title',
    returnLabel: 'Bandeja del Pre-Gestor'
  },
  coordinator: {
    returnTo: '/specialist-coordinator-selection',
    returnLabelKey: 'specialist.selection.coordinator.title',
    returnLabel: 'Bandeja del Coordinador'
  },
  liaison: {
    returnTo: '/specialist-liaison-selection',
    returnLabelKey: 'specialist.selection.liaison.title',
    returnLabel: 'Bandeja del Specialist-Liaison'
  },
  manager: {
    returnTo: '/specialist-manager-selection',
    returnLabelKey: 'specialist.selection.manager.title',
    returnLabel: 'Bandeja del Gestor'
  },
  validator: {
    returnTo: '/specialist-validator-selection',
    returnLabelKey: 'specialist.selection.validator.title',
    returnLabel: 'Bandeja del Verificador'
  },
  editor: {
    returnTo: '/specialist-editor-selection',
    returnLabelKey: 'specialist.selection.editor.title',
    returnLabel: 'Bandeja del Editor'
  }
};

export const MODULE_FICHA_NAV = {
  technology: {
    listPath: '/specialist-technology/',
    newPath: '/specialist-technology/new-technology',
    i18nPrefix: 'technology'
  },
  alternative: {
    listPath: '/specialist-alternative/',
    newPath: '/specialist-alternative/new-alternative',
    i18nPrefix: 'alternative'
  },
  experience: {
    listPath: '/specialist-experience/',
    newPath: '/specialist-experience/new-experience',
    i18nPrefix: 'experience'
  },
  innovation: {
    listPath: '/specialist-innovation/',
    newPath: '/specialist-innovation/new-innovation',
    i18nPrefix: 'innovation'
  },
  assistance: {
    listPath: '/specialist-assistance/',
    newPath: '/specialist-assistance/new-assistance',
    i18nPrefix: 'assistance'
  },
  financial: {
    listPath: '/specialist-financial/',
    newPath: '/specialist-financial/new-financial',
    i18nPrefix: 'financial'
  },
  vision: {
    listPath: '/specialist-vision/',
    newPath: '/specialist-vision/new-vision',
    i18nPrefix: 'vision'
  },
  regulation: {
    listPath: '/specialist-regulation/',
    newPath: '/specialist-regulation/new-regulation',
    i18nPrefix: 'regulation'
  }
};

const readStore = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const persistFichaReturnContext = (process, context = {}) => {
  const key = String(process || '').toLowerCase();
  if (!key) {
    return;
  }
  const store = readStore();
  store[key] = {
    returnTo: context.returnTo,
    returnLabelKey: context.returnLabelKey,
    returnLabel: context.returnLabel,
    trayView: context.trayView || ''
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // sessionStorage puede no estar disponible.
  }
};

export const readFichaReturnContext = (process) => {
  const key = String(process || '').toLowerCase();
  const stored = readStore()[key] || {};
  const nav = MODULE_FICHA_NAV[key] || {};
  return {
    returnTo: stored.returnTo || nav.listPath,
    returnLabelKey: stored.returnLabelKey || (nav.i18nPrefix ? `${nav.i18nPrefix}.page.list` : ''),
    returnLabel: stored.returnLabel || '',
    trayView: stored.trayView || ''
  };
};

export const clearFichaReturnContext = (process) => {
  const key = String(process || '').toLowerCase();
  if (!key) {
    return;
  }
  const store = readStore();
  delete store[key];
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // sessionStorage puede no estar disponible.
  }
};

export const resolveFichaReturnPath = (process, locationState = {}) => {
  const nav = MODULE_FICHA_NAV[String(process || '').toLowerCase()] || {};
  return locationState.returnTo
    || readFichaReturnContext(process).returnTo
    || nav.listPath
    || '/';
};

export const buildFichaNavState = (process, extra = {}) => {
  const nav = MODULE_FICHA_NAV[String(process || '').toLowerCase()] || {};
  const state = {
    returnTo: extra.returnTo || nav.listPath,
    returnLabelKey: extra.returnLabelKey || (nav.i18nPrefix ? `${nav.i18nPrefix}.page.list` : ''),
    returnLabel: extra.returnLabel,
    ...extra
  };
  persistFichaReturnContext(process, state);
  return state;
};
